module.exports = __webpack_public_path__ + "img/profile-folder.8c75dc0d.svg";